import {Box} from "@mui/material";
import {useState} from "react";
import {useAppSelector} from "../../../Config/Hooks";
import InverterSimplePage from "../Powerplant/inverters/InverterSimplePage";
import {QueryClient, QueryClientProvider} from "react-query";

export default function DashboardPowerPlantSkidEquipmentSimplePage() {
    const {selectedEquipment} = useAppSelector((state) => state.dashboard);
    const [queryClient] = useState(() => new QueryClient());
    return (
        <QueryClientProvider client={queryClient}>
            <Box style={{height: '100%', padding: '0 24px 0 22px'}}>
                {selectedEquipment &&
                    <InverterSimplePage equipmentId={selectedEquipment.id} status={selectedEquipment.etsStatus}/>
                }
            </Box>
        </QueryClientProvider>
    );
}
